// 柱状图
<template>
  <div :id="idName"></div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
  name: 'histogram',
  props: {
    idName: String,
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData(val) {
      this.render(val);
    }
  },
  mounted() {
    this.chart = new Chart({
      container: this.idName,
      autoFit: true,
      padding: [20, 40, 60, 80]
    });
    this.render(this.chartData);
  },
  methods: {
    render(data) {
      let chart = this.chart;
      chart.data(data);
      chart.scale('num', {
        nice: true
      });
      chart.axis('date', {
        tickLine: null
      });

      chart.axis('num');

      chart.tooltip({
        showMarkers: false
      });

      chart.legend(false);
      chart
        .interval({
          background: {
            style: {
              radius: 0
            }
          }
        })
        .position('date*num')
        .color('date', '#2194ff');

      chart.render();
    }
  }
};
</script>

<style></style>
